import {
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { ModalProvider } from '@lmt/unicorn-shared/app/components/common/ui-kit/modal/useModal';
import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import '../app.global.css';
import '../App.global.scss';
import './helpers/cached-images';
import { MuiProvider } from './helpers/MuiProvider';

export const GenericEntrypoint: React.FC<React.PropsWithChildren> = (props) => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    }),
  );
  return (
    // <QueryClientProvider client={queryClient}>

    <MuiProvider>
      <ModalProvider>
        <DndContext sensors={sensors}>{props.children}</DndContext>
      </ModalProvider>
    </MuiProvider>
    // </QueryClientProvider>
  );
};
